import gql from "graphql-tag";
export const MEETING_SUBSCRIPTION = gql`
subscription meetingSubscription {
meetingSubscription {
    mutation
    meeting {
      id
      title
      endedAt
      rrule
      summary
      event: when
      nextMeeting {
        totalCount
      }
      actionitemSet {
        edges {
          node {
            id
            title
            meeting {
              id
              title
            }
            okr {
              id
              okrType
              title
            }
            commitment {
              id
              commitment {
                id
                title
              }
              completed
            }
            coachingCommitment {
              id
              coachingcommitment {
                id
                title
              }
              completed
            }
            notes
            completed
            isAgenda
            createdAt
            updatedAt
          }
        }
      }
      member {
        edges {
          node {
            id
            user {
              id
              firstName
              lastName
              email
              profile {
                id
                profileImage
              }
            }
          }
        }
      }
      owner {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
`